import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const companyApi = {
    //公司信息
    "getCompanyInfo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/getCompanyInfo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null
            }
        }
    },
    //修改公司信息
    "updateCompany": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/updateCompany`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                address: null,
                companycode: null,
                companyname: null,
                email: null,
                fax: null,
                id: null,
                mobilephone: null,
                poscash: null,
                sharewhcom: null,
                telephone: null,
                website: null,
                logo: null,  //公司Logo
            }
        }
    },
    //查詢公司職位
    "queryPosition": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/queryPosition`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
            }
        }
    },
    //查詢公司部門
    "getCompanyDepartment": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/getCompanyDepartment`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
            }
        }
    },
    //刪除公司部門
    "deleteDepartment": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/deleteDepartment`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                companycode: null,
            }
        }
    },
    //添加公司部門
    "addDepartment": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/addDepartment`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                departmentname: null,
                companycode: null,
            }
        }
    },
    //添加公司職位
    "addPosition": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/addPosition`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                positionname: null,
                companycode: null,
            }
        }
    },
    //刪除公司職位
    "deletePosition": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/deletePosition`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                companycode: null,
            }
        }
    },
    //修改員工信息
    "updateStaffInfo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/updateStaffInfo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo2: null,
                companycode: null,
                id: null,
                login: null,
                memmale: null,
                memposition: null,
                mpfaccount: null,
                name: null,
                password: null,
                positionname: null,
                telephone: null,
                token: null,
                memberwork: {
                    id: null,
                    addinfo8: null,
                    addinfo9: null
                }
            }
        }
    },
    //設置或者取消管理員
    "updateStaffAdmin": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/updateStaffAdmin`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo6: null,
                companycode: null,
                id: null,
            }
        }
    },
    //添加員工
    "addStaff": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/addStaff`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo3: null,
                companycode: null,
                department: null,
                login: null,
                memmale: null,
                memposition: null,
                mpfaccount: null,
                name: null,
                password: null,
                repassword: null,
                positionname: null,
                telephone: null,
            }
        }
    },
    //邀請已存在的用戶
    "inviteUser": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/inviteUser`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo1: null,
                companycode: null,
                department: null,
                login: null,
                memposition: null,
                name: null,
            }
        }
    },
    //填寫公司初始化信息
    "inputCompanyInfo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/inputCompanyInfo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                // "id": null,    //公司id 已棄用
                "companycode": null,
                "companyname": null,
                "companyname2": null,
                "email": null,
                "telephone": null,
                "mobilephone": null,  //公司電話2
                // "poscash": null,  //whatsapp號碼 已棄用
                "fax": null,
                "website": null,
                "address": null,
                // "address2": null,  //公司地址2 已棄用
                "login": null,
                "userId": null, //用戶id
                "token": null,
                "chatId": null,
                "sharewhcom": null,
                // "worktype": null, //公司類別 已棄用
                "blockasp": null,  //是否為個人公司 -1是 0否
                "currcode": null  //貨幣單位
            }
        }
    },
    //修改公司eshopopee公司代碼
    "updateCompanyAcccompanycode": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/updateCompanyAcccompanycode`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                "id": null,   //company id
                "acccompanycode": null,
            }
        }
    },
    //修改公司eshopopee店鋪狀態
    "updateCompanyProductverify": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/updateCompanyProductverify`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                "companycode": null,   //company id
                "productverify": null,
            }
        }
    },
    //開通新地區的公司
    "newCountryCompany": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/newCountryCompany`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null, //userid
                addinfo2: null, //聊天id
                addinfo3: null, //companyname
                country: null,
                token: null,
                blockasp: 0,
                email: null,
                telephone: null,
                address: null,
                attdate2: null,  //companyname2
                fax: null,
                marital: null,  //website
                salaryperiod: null, //sharesocom
                salaryaccount: null  //貨幣單位
            }
        }
    },
    //首次開通店鋪時贈送時長
    "insertGiftBoForNew": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/insertGiftBoForNew`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo3: null,
                companycode: null,
                name: null,
                telephone: null,
            }
        }
    },
    //查询3d城中的店铺
    "getShopListForThree": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/getShopListForThree`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                countrycode: null,
            }
        }
    },
    //查询对应展馆的店铺
    "getHallListForThree": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/getHallListForThree`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,  //展馆id
            }
        }
    },
    //保存店铺浏览记录
    "addShopVisits": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/addShopVisits`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,  //company id
            }
        }
    },
    //关键字分页查询店铺记录
    "getCompany3DInfoByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/getCompany3DInfoByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                acccompanycode: -4,
                companyname: null, //搜索关键字
                districtcode: null, //父公司code
                pageNum: 1,
                pageSize: 20
            }
        }
    },
    //关键字分页查询公司3D信息
    "getCompany3DDetailByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/getCompany3DDetailByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                acccompanycode: -4,
                companyname: null, //搜索关键字
                districtcode: null, //父公司code
                pageNum: 1,
                pageSize: 20
            }
        }
    },
    //获取公司基本信息
    "getSimpleCompanyInfoByCompanycode": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/getSimpleCompanyInfoByCompanycode`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null
            }
        }
    },
    //查詢邀請碼的相關信息
    "queryCompanyInvCode": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/queryCompanyInvCode`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null  //邀請碼
            }
        }
    },
    //初始化新注册的公司信息
    "initNewCompanyInfo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/inputCompanyInfo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                // "id": null,
                "companycode": null,
                "companyname": null,
                "companyname2": "",
                "email": null,
                "telephone": null,
                "mobilephone": "",
                "poscash": "",
                "fax": "",
                "website": "",
                "address": null,
                "address2": "",
                "login": null,
                "userId": null,
                "token": null,
                "chatId": null,
                "sharewhcom": null,
                // "worktype": null,
                "blockasp": "-1"
            }
        }
    },
    //查詢獨立部署的公司
    "queryServerCompanyList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/queryServerCompanyList`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {

            }
        }
    },
    //查詢公司
    "queryCompany": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/queryCompany`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {

            }
        }
    },
    //同步數據到EShopopee
    "syncEShopopeeDataByCompanycode": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/syncEShopopeeDataByCompanycode`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null
            }
        }
    },
    //公司注销
    "logoffCompanyData": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/logoffCompanyData`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                token: null
            }
        }
    },
    //獲取公司展館和對應的產品
    "getCompanyHallInfo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/getCompanyHallInfo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null
            }
        }
    },
    //查詢3D城需要的信息
    "getCityInfoForThree": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/getCityInfoForThree`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                countrycode: null,
            }
        }
    },
    //查詢公司的詳細3d信息
    "queryCompany3DInfo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}company/queryCompany3DInfo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
            }
        }
    }
}

export default companyApi